import React from "react";
import styled from "theme/libs/styled";
import Loading from "theme/components/Loading";

const Wrapper = styled("div")`
    position: relative;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ViewsLoading = () => {
    return (
        <Wrapper>
            <Loading />
        </Wrapper>
    );
};

export default ViewsLoading;
